// BREACH STATUS
export const GET_BREACH_STATUSES = '/breach-status/query';
export const GET_BREACH_STATUS = '/breach-status/';
export const POST_BREACH_STATUS = '/breach-status/';
export const PUT_BREACH_STATUS = '/breach-status/';
export const DELETE_BREACH_STATUS = '/breach-status/';
